@if (isEmpty()) {
  <div class="cart-summary__empty">
    <img
      class="cart-summary__empty-mascot"
      [src]="mascotUrl"
      alt=""
      loading="lazy"
    />
    <h3 class="cart-summary__empty-title">Tu carrito está vacío</h3>
    <p class="cart-summary__empty-subtitle">Añade productos para continuar</p>
    <app-button variant="secondary" (click)="onExploreClick()">
      Explorar tienda
    </app-button>
  </div>
} @else {
  <section class="cart-summary" aria-label="Resumen del pedido">
    <h2 class="cart-summary__title">Resumen del pedido</h2>

    @if (blockedNotice(); as notice) {
      <p class="cart-summary__blocked-notice" role="alert">{{ notice }}</p>
    }

    <ul class="cart-summary__lines" role="list">
      @for (line of lines(); track line.id) {
        <li>
          <article
            class="cart-summary__line"
            [class.cart-summary__line--blocked]="isLineBlocked(line.id)"
          >
            <img
              class="cart-summary__line-img"
              [src]="lineImageUrl(line)"
              [alt]="line.name"
              loading="lazy"
              (error)="onImageError($event)"
            />
            <div class="cart-summary__line-info">
              <div class="cart-summary__line-heading">
                <p class="cart-summary__line-name">{{ line.name }}</p>
                @if (isLineBlocked(line.id)) {
                  <app-badge variant="vip">{{ blockedCopy.label }}</app-badge>
                }
                @if (lineHasOffer(line)) {
                  <app-badge variant="sale">-{{ lineDiscountPct(line) }}%</app-badge>
                }
              </div>
              <p class="cart-summary__line-meta">
                {{ line.quantity }} ×
                @if (lineOriginalPrice(line); as original) {
                  <span class="cart-summary__line-original">{{ formatCRC(original) }}</span>
                }
                {{ formatCRC(lineUnitPrice(line)) }}
              </p>
              @if (isLineBlocked(line.id)) {
                <div class="cart-summary__line-blocked" role="alert">
                  <p class="cart-summary__line-blocked-text">{{ blockedReason(line.id) }}</p>
                  <button
                    class="cart-summary__line-blocked-cta"
                    type="button"
                    [disabled]="removingLineId() !== null"
                    (click)="onRemoveBlocked(line)"
                  >
                    {{ blockedCopy.removeCta }}
                  </button>
                </div>
              }
            </div>
            <div class="cart-summary__line-subtotal-col">
              <p class="cart-summary__line-subtotal">{{ formatCRC(lineSubtotal(line)) }}</p>
              @if (linePoints(line) > 0) {
                <p class="cart-summary__line-points">
                  <app-pp-coin [size]="14" />{{ withPoints(ppCopy.lineChip, linePoints(line)) }}
                </p>
              }
            </div>
          </article>
        </li>
      }
    </ul>

    <div class="cart-summary__totals">
      <!-- Subtotal de productos en BRUTO (con IVA, pre-descuento) = total + discounts.
           cart.subtotal/taxes del API vienen YA descontados (IVA sobre base descontada),
           así que mostrarlos como "Subtotal/IVA" + "Descuento" no cuadraría a la vista. -->
      <div class="cart-summary__totals-row">
        <span>Subtotal</span>
        <span>{{ formatCRC((cart()?.total ?? 0) + (cart()?.discounts ?? 0)) }}</span>
      </div>
      @if ((cart()?.discounts ?? 0) > 0) {
        <div class="cart-summary__totals-row cart-summary__totals-row--discount">
          <span>Descuento</span>
          <span>−{{ formatCRC(cart()?.discounts ?? 0) }}</span>
        </div>
      }
      @if (deliveryMethod()) {
        <div class="cart-summary__totals-row">
          <span>Envío</span>
          <span>
            @switch (deliveryMethod()) {
              @case ('ps') { Retiro en tienda }
              @case ('uber') { Por tu cuenta }
              @case ('ps_delivery') { {{ formatCRC(deliveryPrice()) }} }
              @case ('other_shop') {
                @if (deliveryPrice() > 0) {
                  {{ formatCRC(deliveryPrice()) }}
                } @else {
                  —
                }
              }
              @case ('home') {
                @if (deliveryPrice() > 0) {
                  {{ formatCRC(deliveryPrice()) }}
                } @else {
                  Gratis
                }
              }
            }
          </span>
        </div>
      }
      <div class="cart-summary__totals-row cart-summary__totals-row--total">
        <span>Total</span>
        <span>{{ formatCRC((cart()?.total ?? 0) + deliveryPrice()) }}</span>
      </div>
      @if ((cart()?.taxes ?? 0) > 0) {
        <div class="cart-summary__totals-row cart-summary__totals-row--tax-note">
          <span>IVA incluido</span>
          <span>{{ formatCRC(cart()?.taxes ?? 0) }}</span>
        </div>
      }
      @if (authoritativePoints() > 0) {
        <div class="cart-summary__totals-row cart-summary__totals-row--points">
          <app-pp-coin [size]="14" />
          <span>{{ withPoints(ppCopy.totalRow, authoritativePoints()) }}</span>
        </div>
        <p class="cart-summary__points-note">{{ ppCopy.clarification }}</p>
      }
    </div>

    @if (activePromo(); as applied) {
      <div class="cart-summary__promo">
        <div class="cart-summary__promo-header">
          <span class="cart-summary__promo-badge">{{ applied.code }}</span>
          @if (applied.valueLabel) {
            <span class="cart-summary__promo-value">−{{ applied.valueLabel }}</span>
          }
        </div>
        @if (applied.description) {
          <p class="cart-summary__promo-description">{{ applied.description }}</p>
        }
      </div>
    }

    @if (freeShippingMissing(); as missing) {
      <p class="cart-summary__free-shipping" role="status">
        Te faltan <strong>{{ formatCRC(missing) }}</strong> para que el envío sea gratis.
      </p>
    }
  </section>
}
